// extracted by mini-css-extract-plugin
export var bodySections = "_8m-8";
export var gray = "_8m-7";
export var green = "_8m-4";
export var iconContainer = "_8m-9";
export var iconWidgetContainer = "_8m-1";
export var phoneIcon = "_8m-2";
export var red = "_8m-5";
export var statusDot = "_8m-3";
export var widgetContainer = "_8m-0";
export var yellow = "_8m-6";